import { Route, useHistory, useLocation } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import CookiesStorageService from './CookiesStorageService'
import ResponsiveAppBar from '../components/ResponsiveAppBar'
import NotAuthorized from '../pages/Errors/NotAuthorized/index.jsx'
import { isNotEmpty } from '../utils/helpers'
import AppRoutes from './AppRoutes'

const PrivateRoute = ({
  sysAdminComponent: SysAdminComponent,
  csAdminComponent: CsAdminComponent,
  ...props
}) => {
  const [authUser, setAuthUser] = useState('init')
  const history = useHistory()
  const location = useLocation();

  useEffect(() => {
    if (
      CookiesStorageService.getAdminType() === 'sys_admin' ||
      CookiesStorageService.getAdminType() === 'customer_admin'
    ) {
      setAuthUser(true)
    } else {
      if (isNotEmpty(CookiesStorageService.getAccessToken())) {
        history.push(AppRoutes.landing)
      }
      setAuthUser(false)
    }
  }, [])

  useEffect(() => {
    if (authUser) {
      const isFirstLogin = CookiesStorageService.getIsFirstLogin();
      if (isFirstLogin) {
        history.push(AppRoutes.firstTimePassword);
      }
    }
  }, []);

  useEffect(() => () => {
    window.scrollTo({ top: 0 })
  }, [location.pathname]);

  if (authUser) {
    return (
      <Route
        component={() => (
          <>
            <ResponsiveAppBar adminType={CookiesStorageService.getAdminType()} />
            {CookiesStorageService.getAdminType() === 'sys_admin' && <SysAdminComponent />}
            {CookiesStorageService.getAdminType() === 'customer_admin' && <CsAdminComponent />}
          </>
        )}
        {...props}
      />
    )
  }

  if (!authUser) {
    return <Route component={NotAuthorized} />
  }

  return ''
}

export default PrivateRoute
